import { atom } from "recoil";

export const customDialogState = atom<{
  title: string;
  isCancel?: boolean;
  confirm: any;
  confirmText?: string;
  cancelText?: string;
  cancel?: any;
  confirmColor?: string;
  cancelColor?: string;
} | null>({
  key: "custom-dialog",
  default: null,
});
